import {Column, Entity, ManyToOne, PrimaryGeneratedColumn} from "typeorm";
import { User } from "./User";

@Entity()
export class CustomAddress {

	@PrimaryGeneratedColumn({ name:"id" })
	id?: number

	@Column({ nullable: true }) 
  addressType?: string

  @Column({ nullable: true }) 
  addressLine1?: string

  @Column({ nullable: true }) 
  addressLine2?: string

  @Column({ nullable: true }) 
  city?: string

  @Column({ nullable: true }) 
  region?: string

  @Column({ nullable: true }) 
  postalCode?: string

  @Column({ nullable: true }) 
  country?: string

  @ManyToOne(() => User, (user) => user.customDeliveryAddresses)
    user?: User

}